<template>
  <main class="main-content mt-0 pb-5">
    <div class="page-header align-items-start pt-2 m-3 border-radius-lg">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white">Accedi</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container pb-4 px-0">
      <div class="row justify-content-center">
        <div class="col-xl-7 col-lg-7 col-md-7 mx-auto">
          <div class="card z-index-0">

            <div class="card-body pb-2">
              <div class="w-50 my-4 pb-4 mx-auto">
                <router-link class="text-center d-block" to="/">
                  <img :src="logo" class="logo" alt="outletarredamento.it" />
                </router-link>
              </div>
              <form role="form" @submit.prevent="submitForm">
                <div class="container">
                  <div class="row">
                    <div class="col-12">
                      <label for="email" class="form-label">Email</label>
                      <input name="email" type="email" class="form-control" id="email" v-model="this.formData.email"
                        @blur="v$.formData.email.$touch">
                      <div class="mb-3" :class="{ error: v$.formData.email.$errors.length }">
                        <div class="input-errors" v-for="error of v$.formData.email.$errors" :key="error.$uid">
                          <span class="error-msg custom-red text-xs">{{ error.$message }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">

                      <div class="text-center">
                        <div class="form-check my-2 ps-0 text-center">
                          <input class="submit btn bg-custom-red my-3 text-white badge-pill px-4" type="submit"
                            value="Accedi">

                        
                          <vue-recaptcha v-show="showRecaptcha" sitekey="6LfXfl0pAAAAADh_2wA1XuPjQq89NDZvvqzWfREU"
                            size="invisible" theme="light" hl="it" :loading-timeout="loadingTimeout"
                            @verify="recaptchaVerified" @expire="recaptchaExpired" @fail="recaptchaFailed"
                            @error="recaptchaError" ref="vueRecaptcha" />
                        
                          <div class="my-3">
                            <a class="text-custom-blue"
                                href="mailto:supporto.outlet@preludeadv.it">Assistenza area riservata rivenditori </a>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-7 mx-auto mt-2">
          <div class="card z-index-0">
            <div class="container-fluid pt-4">
              <div class="row align-items-end">
                <div class="col-6">
                  <h6>Sei un rivenditore o un'azienda? Contattaci</h6>
                  <p class="mb-0">Scegli il nostro marketplace dell'arredo casa per implementare il tuo business. </p>
                </div>
                <div class="col-6 text-end">
                  <a href="/contatti" title="Trova Rivenditori" class="btn btn-sm mb-0 px-4 btn-outline-dark"
                    target="_blank">Contattaci ora</a>
                </div>
              </div>
            </div>

            <div class="card-body pb-2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import logo from "@/assets/img/logo.svg";
import fetchComp from "@/utils/fetchComp";
import { SET_AUTHENTICATION, SET_SELLER } from "@/store/auth/const";
import { GET_MESSAGE, SET_MESSAGE } from "@/store/sysMessage/const";
import { SET_BUSY } from "@/store/overlay/const";
import { useVuelidate } from '@vuelidate/core';
import { helpers, required, email } from '@vuelidate/validators';

const requiredIta = helpers.withMessage('Campo obbligatorio', required);
const emailIta = helpers.withMessage('Inserire una email valida', email);

import vueRecaptcha from 'vue3-recaptcha2';
export default {
  name: "Signin",
  setup() {
    const { login, checkAuth, WAToken, WAAuth } = fetchComp();
    return {
      v$: useVuelidate(),
      login,
      checkAuth,
      WAToken,
      WAAuth,
    }
  },
  components: { vueRecaptcha },
  data() {
    return {
      logo,
      formData: {
        email: "",
      },
      formSubmitted: false,
      queryData: this.$route.query,
      showRecaptcha: true,
      loadingTimeout: null
    }
  },
  methods: {
    submitForm: async function () {
     

      this.formSubmitted = true;
      const isFormOk = await this.v$.$validate();
      if (isFormOk) {
        this.$refs.vueRecaptcha.execute();
      } else {
        this.$store.commit(`auth/${SET_AUTHENTICATION}`, false);
        const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
        sysMessageStateObj.haveContent = true;
        sysMessageStateObj.messageText = "Errore durante il login: controlla i tuoi dati"
        sysMessageStateObj.messageType = "error";
        this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
      }
    },
    recaptchaVerified(response) {
     
      const formData = { ...this.formData };
      formData.gToken = response;
      
      if (Object.keys(this.queryData).length) {
        this.checkAuth({ 't': this.queryData.t, 'i': this.queryData.i, 'g': response, 'c': this.queryData.chisono ?? 'pluto' }).then((resp) => {
          const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
          if (resp.result == "ok") {
            sysMessageStateObj.haveContent = true;
            sysMessageStateObj.messageText = "Login effettuato";
            sysMessageStateObj.messageType = "success";
            this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
            this.$store.commit(`auth/${SET_AUTHENTICATION}`, true);
            this.$store.commit(`auth/${SET_SELLER}`, resp);
            this.$store.state.showSidenav = true;
            this.$router.push('/requests');
          } else {
            this.$store.commit(`auth/${SET_AUTHENTICATION}`, false);
            sysMessageStateObj.haveContent = true;
            sysMessageStateObj.messageText = resp.message;
            sysMessageStateObj.messageType = "error";
            this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
            window.location.replace(window.location.href.replace(window.location.search, ''));
            this.$store.commit(`overlay/${SET_BUSY}`, false);
          }
        })
      } else {
        this.login(formData).then((resp) => {
          const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
          if (resp.result == "ok") {
            sysMessageStateObj.haveContent = true;
            sysMessageStateObj.messageText = "Controlla la tua posta, ti abbiamo inviato un link per accedere";
            sysMessageStateObj.messageType = "success";
            this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
          } else {
            this.$store.commit(`auth/${SET_AUTHENTICATION}`, false);
            sysMessageStateObj.haveContent = true;
            sysMessageStateObj.messageText = "Errore durante il login: controlla i tuoi dati";
            sysMessageStateObj.messageType = "error";
            this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
          }
        })
      }
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() {
    },
    recaptchaError(reason) {
      return reason;
    }
  },
  validations() {
    return {
      formData: {
        email: { requiredIta, emailIta },
      }
    }
  },
  mounted() {
    this.$store.state.showSidenav = false;
    this.$store.commit(`overlay/${SET_BUSY}`, false);
    if (Object.keys(this.queryData).length) {
      if (this.queryData.t && this.queryData.i) {
        this.$store.commit(`overlay/${SET_BUSY}`, true);
        const sysMessageStateObj = this.$store.getters[`sysMessage/${GET_MESSAGE}`];
        sysMessageStateObj.haveContent = true;
        sysMessageStateObj.messageText = "Verifico i tuoi dati";
        sysMessageStateObj.messageType = "info";
        this.$store.commit(`sysMessage/${SET_MESSAGE}`, sysMessageStateObj);
        setTimeout(() => {
          this.$refs.vueRecaptcha.execute();
        }, 2000);
      }
    }
  }
}
</script>
<style scoped>
.badge {
  min-width: 200px;
}

.badge-pill {
  border-radius: 10rem;
  border: 1px solid rgba(255, 255, 255, 0);
  padding: .75rem 1.2rem;
}
</style>
